exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-3{position:relative;width:100%;height:100%}.dv-border-box-3 .dv-border-svg-container{position:absolute;width:100%;height:100%;top:0;left:0}.dv-border-box-3 .dv-border-svg-container>polyline{fill:none}.dv-border-box-3 .dv-bb3-line1{stroke-width:3}.dv-border-box-3 .dv-bb3-line2{stroke-width:1}.dv-border-box-3 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox3/src/main.css
// module id = 1074
// module chunks = 45